import { track } from "@vercel/analytics";

/**
 * Tynne wrappers over @vercel/analytics track() for kjerne-konverteringer.
 * Vercel Analytics tar imot egendefinerte events i tillegg til pageviews
 * uten cookies. Bruk konsistente snake_case-event-navn så de er enkle å
 * filtrere i dashboardet.
 */

export function trackAddToCart(input: {
  productSlug: string;
  variantId: string;
  priceOre: number;
  quantity: number;
}) {
  track("add_to_cart", {
    product_slug: input.productSlug,
    variant_id: input.variantId,
    price_nok: input.priceOre / 100,
    quantity: input.quantity,
  });
}

export function trackBeginCheckout(input: { itemCount: number; totalOre: number }) {
  track("begin_checkout", {
    item_count: input.itemCount,
    total_nok: input.totalOre / 100,
  });
}

export function trackPurchase(input: {
  orderId: string;
  totalOre: number;
  itemCount: number;
}) {
  track("purchase", {
    order_id: input.orderId,
    total_nok: input.totalOre / 100,
    item_count: input.itemCount,
  });
}

export function trackFastgiverStarted(input: { amountNok: number }) {
  track("fastgiver_signup_started", {
    amount_nok: input.amountNok,
  });
}

export function trackFastgiverCompleted(input: { agreementId: string; amountNok: number }) {
  track("fastgiver_signup_completed", {
    agreement_id: input.agreementId,
    amount_nok: input.amountNok,
  });
}

export function trackContactSubmit() {
  track("contact_form_submit");
}

export function trackEventSignup(input: { eventId: string; numAttendees: number }) {
  track("event_signup", {
    event_id: input.eventId,
    num_attendees: input.numAttendees,
  });
}
